import React from 'react';
import Helmet from 'react-helmet';
import { Link } from '@reach/router';

import Navigation from '../../components/WaveNavigation/';
import Island from '../../components/Island/';
import Instagram from '../../components/Cards/instagram';
import PageHeader from '../../components/PageHeader';
import Amenities from '../../utils/amenities';
import Tip from '../../components/Tips';

import fiferries from '../../assets/img/instagram/profiles/fiferries.jpg';
import instagram from './images/replaceME.jpg';

export default () => (
  <div>
    <Helmet
      title='Fire Island Ferries | Dunewood'
      meta={[
        {
          name: 'description',
          content: 'A small community in a charming hamlet of Fire Island.',
        },
        {
          name: 'keywords',
          content:
            'Dunewood, Fire Island, New York, Long Island, Ferries, Water Taxi',
        },
      ]}
    />
    <Navigation />
    <div className='container p-0'>
      <PageHeader beach='Dunewood'>
        <h2>Communities</h2>
        <h1>Dunewood</h1>
        <p>Amenities</p>
        <div className='amenities'>
          {Amenities.byBeach('Dunewood').map((item) => (
            <i
              key={item.text}
              className={`icon-${item.icon}`}
              title={item.text}
            />
          ))}
        </div>
        <div>
          <Link className='btn btn-outline-light' to='/schedules/dunewood'>
            Schedules
          </Link>
          &nbsp;&nbsp;
          <Link className='btn btn-outline-light' to='/directory'>
            Directory
          </Link>
        </div>
      </PageHeader>
    </div>
    <div className='container page'>
      <div className='row'>
        <div className='col-xl'>
          <div className='heading'>
            <h1>About Dunewood</h1>
          </div>
          <p>
            One of the smaller communities on Fire Island; this charming hamlet
            is home to ninety-nine houses. There is a small bay beach that
            provides kids and adults with a place to swim in the Great South Bay
            while overseen by lifeguards.
          </p>
          <p>
            Dunewood also has a yacht club, where kids can learn to sail on
            Sunfish, and resident-only tennis courts where generations have
            played tennis. It neighbors the reclusive community of Lonelyville
            where residents find plenty of peace, quiet, and relaxation.
          </p>
        </div>
        {/* <div className="col-xl-4">
          <Instagram account="fiferries" datestamp="June 23, 2016" profile={fiferries} image={instagram} link="https://www.instagram.com/fiferries" className="mx-auto" />
        </div> */}
      </div>
      <Tip title="Captain's Tip">
        The Water Taxi leaves from the little “L” dock east of the ferry dock.
      </Tip>
      <h1>Transportation</h1>
      <p>
        Ferry service to and from Dunewood is available by Fire Island Ferries
        from Bay Shore.{' '}
        <Link to='/schedules/dunewood'>Click here for schedules.</Link>
      </p>
      <p>
        <a href='http://www.fireislandwatertaxi.com'>Water Taxi</a> service is
        available to and from Dunewood during in-season operation.
      </p>
      <Island />
    </div>
  </div>
);
